module.exports = __webpack_public_path__ + "static/media/jm.1b388cb2.svg";